<script setup>
import { provide, ref, watch, onMounted } from "vue";
import { __, formFragmentValues, setFormFragmentValues } from '@/utils'
import RoamingStepForm from '@components/RoamingStepsForm/roaming-steps-form.vue';
import SuccessPage from '@components/RoamingStepsForm/success-page.vue';
import stepTwo from '@components/RoamingStepsForm/steps/step-two.vue';
import stepThree from '@components/RoamingStepsForm/steps/step-three.vue';
import navigation from '@components/stepsNavigation.vue';

const steps = [
	{ title: __('Selecting a mobile plan') },
	{ title: __('Customer details') },
	{ title: __('To payment') },
];

const localValues = formFragmentValues();
const activeStep = ref(localValues.activeStep ? parseInt(localValues.activeStep) : 2);
const validSteps = ref({
    1: false,
    2: false,
    3: false,
})

const setActiveStep = (step) => {
    activeStep.value = step
};
const nextStep = () => activeStep.value + 1;
const currStep = () => activeStep.value;
const prevStep = () => activeStep.value - 1;
const setValidStep = (value) => validSteps.value[activeStep.value] = value;
const isTargetStepValid = (step) => validSteps.value[step];

const hideForm = ref(false);
const showSuccessPage = ref(localValues.showSuccessPage ? localValues.showSuccessPage : false);


onMounted(() => {
    document.body.classList.remove('loading');
});

provide('step', {
    activeStep,
    setActiveStep,
    nextStep,
    prevStep,
    showSuccessPage,
    isTargetStepValid,
    hideForm,
    validSteps,
    setValidStep,
    currStep,
});
 
watch(activeStep, (newVal) => {
    setFormFragmentValues({
        activeStep: newVal
    })
});
</script>

<template>
    <RoamingStepForm v-if="!hideForm">
        
        <navigation 
            :steps="steps"
            iconType="roaming-step"
            :showBackBtn="false"
            :blockedStep="1"
        />

       <div class="form__content">
            <stepTwo v-if="activeStep == 2" />
            <stepThree v-if="activeStep == 3" />
        </div>  <!-- /.form__content -->
    </RoamingStepForm>
    <SuccessPage v-if="showSuccessPage"/>
</template>